module.exports = __webpack_public_path__ + "static/index/img/baikal-802.13c9b45f.jpg";